/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    BASIC_FUNCTIONALITY: 1,
    CREATE_LECTURER: 2,
    SOMETHING_ELSE: 4,
};
